const $header = $('.site-header');
const $fixedVideo = $('.js-fixed-video');
const $fixedContent = $('.js-fixed-content');
const $window = $(window);

/**
 * Adjusting Video Height
 *
 * @return {Void}
 */
function adjustingVideoHeight() {
  const windowHeight = $window.outerHeight();
  const headerHeight = $header.outerHeight();
  let contentHeight = $fixedContent.outerHeight();
  const vh = ((windowHeight - headerHeight) / windowHeight) * 100;
  contentHeight = contentHeight + 85;

  $fixedVideo.css('width', 'calc(' + vh + 'vh' + ' - ' + contentHeight + 'px)');
}

/**
 * Remove Effect
 *
 * @return {Void}
 */
function removeEffect() {
  $fixedVideo.css('width', '');
}

// if  ($window.width() <= 769) {
//   adjustingVideoHeight()
// }

// Video Resize on Mobile

// $window.on('resize', function() {
//   if  ($window.width() <= 769) {
//     adjustingVideoHeight();
//   } else {
//     removeEffect();
//   }
// })
